/**
 * Edge Config key constants
 * Centralized location for all Edge Config keys used throughout the application
 *
 * @constant {Object} EDGE_CONFIG_KEYS
 */
export const EDGE_CONFIG_KEYS = {
  // Banner configuration
  TOP_BANNER_DISPLAY: "top_banner_display",
  TOP_BANNER_TEXT: "top_banner_text",
  TOP_BANNER_CTA_TEXT: "top_banner_cta_text",
  TOP_BANNER_CTA: "top_banner_cta",

  // Promotion configuration - Scalable system for managing promotions
  // PRIMARY: Use this to explicitly set which promotion is active (recommended)
  ACTIVE_PROMOTION: "active_promotion", // Set to "spring_savings", "summer_deals", etc.

  // Promotion flags (set to "true" to activate) - Alternative method
  PROMOTION_SPRING_SAVINGS: "spring_savings", // Future use
  PROMOTION_SUMMER_DEALS: "summer_deals", // Future use

  // Blog CTA configuration
  BLOG_CTA_TYPE: "blog_cta_type",

  // Blog Popup configuration
  BLOG_POPUP_TYPE: "blog_popup_type",
};

/**
 * Promotion types mapping
 * Maps promotion flags to their display components and metadata
 */
export const PROMOTION_TYPES = {
  spring_savings: {
    name: "Spring Savings",
    slug: "spring-savings",
    ctaComponent: "spring_savings",
    popupComponent: "spring_savings",
    path: "/promotions/spring-savings",
    colorScheme: "fresh", // Green/blue spring colors
  },
  summer_deals: {
    name: "Summer Deals",
    slug: "summer-deals",
    ctaComponent: "summer_deals",
    popupComponent: "summer_deals",
    path: "/promotions/summer-deals",
    colorScheme: "bright", // Yellow/orange summer colors
  },
};

/**
 * Edge Config key groups for batch fetching
 */
export const EDGE_CONFIG_GROUPS = {
  BANNER: [
    EDGE_CONFIG_KEYS.TOP_BANNER_DISPLAY,
    EDGE_CONFIG_KEYS.TOP_BANNER_TEXT,
    EDGE_CONFIG_KEYS.TOP_BANNER_CTA_TEXT,
    EDGE_CONFIG_KEYS.TOP_BANNER_CTA,
  ],
  PROMOTIONS: [
    EDGE_CONFIG_KEYS.ACTIVE_PROMOTION,
    EDGE_CONFIG_KEYS.PROMOTION_SPRING_SAVINGS,
    EDGE_CONFIG_KEYS.PROMOTION_SUMMER_DEALS,
  ],
};
